/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import moment from "moment";
import { FormattedMessage, IntlShape } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Column } from "react-table";

import getLabel from "helpers/getLabel";
import Badge from "components/atoms/Badge/Badge";
import DuplicateShipment from "components/molecules/DuplicateShipment/DuplicateShipment";
import Button from "components/atoms/Button/Button";
import { formatDatetime, formatWeight, roundTo } from "helpers/commonHelpers";
import Cookies from "js-cookie";
import { ReactComponent as EditIcon } from "assets/images/icons/SubmitIcon.svg";
import { ReactComponent as ResetIcon } from "assets/images/icons/Reset.svg";
import { convertQuickRequest, startEditQuickRequest } from "api";
import { useNavigate } from "react-router-dom";
import errorToast from "helpers/errorToast";
import { useState } from "react";
import { QuickRequestStatusColors } from "constants/";
import { DateTimeFormat, formatIfValid } from "helpers/dateTimeHelper";

const getQuickListingColumns = (
  intl: IntlShape,
  status: string,
  paymentLocationsHashMap: Record<string, any>,
  handleShipmentIdClick: Function,
  quotingPermissions: {
    create_quote_requests: boolean;
    create_quick_requests: boolean;
  },
  navigate: ReturnType<typeof useNavigate>,
) => {
  const { create_quote_requests: canCreateQuoteRequest, create_quick_requests: canCreateQuickRequest } = quotingPermissions;
  let columns: Column[] = [
    {
      id: "shipment",
      Header: intl.formatMessage({
        id: status === "draft" ? "general.draft" : "general.shipment",
        defaultMessage: status === "draft" ? "Draft" : "Shipment",
      }),
      accessor: "quick_request_reference",
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      sortable: true,
      Cell: ({ value, row }: any) => {
        if (row.original?.quick_request_title) {
          return (
            <>
              <div className="d-flex">
                <p className="font-b4 mb-1">{value} </p>
                {row.original?.related_shipment && (
                  <Button
                    variant="link"
                    className="ml-2 p-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShipmentIdClick(row.original?.related_shipment, row.original?.status);
                    }}
                  >
                    ({row.original?.related_shipment})
                  </Button>
                )}
              </div>

              <span>{row.original?.quick_request_title}</span>
            </>
          );
        }

        return (
          <>
            <p>{value}</p>
            <span>{row.original?.quick_request_title}</span>
          </>
        );
      },
    },
    {
      Header: intl.formatMessage(
        {
          id: "general.paymentLocation",
          defaultMessage: "Payment location",
        },
        { paymentLocation: getLabel("Payment location", "capitalize-first") },
      ),
      accessor: "payment_location",
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      sortable: true,
      Cell: ({ value, row }: any) => (
        <>
          <p className="mb-0">{status === "draft" ? paymentLocationsHashMap[value]?.label : value}</p>
          <span className="text-primary mt-2">
            {status === "draft" && typeof row.original?.created_by === "string" ? (
              row.original?.created_by
            ) : (
              <OverlayTrigger
                placement="top"
                delay={{ show: 50, hide: 50 }}
                overlay={<Tooltip id="button-tooltip">{row.original?.created_by?.email}</Tooltip>}
              >
                <span>{row.original?.created_by?.name}</span>
              </OverlayTrigger>
            )}
          </span>
        </>
      ),
    },
    {
      id: "route",
      Header: intl.formatMessage({
        id: "quote.listing.fromTo",
        defaultMessage: "From-to",
      }),
      accessor: "pickup_city",
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      Cell: ({ value, row }: any) => {
        if (!value && !row.original?.stop1_city) return <div className="mb-0">-</div>;
        const deliveryDate = row.original?.expected_delivery_datetime;
        const pickupDate = row.original?.expected_pickup_datetime;
        const pickupCity = row.original?.pickup_city;
        const deliveryCity = row.original?.stop1_city;
        return (
          <>
            <div>
              <div className="d-flex justify-content-between w-190-px">
                <div className="font-b5 overflow-hidden text-truncate text-secondary w-90-px">
                  <span>{pickupCity}</span>
                  <div className="text-primary text-truncate">
                    {Array.isArray(pickupDate) ? (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 50 }}
                        overlay={
                          <Tooltip id="button-tooltip">
                            {formatDatetime(pickupDate[0])} - {formatDatetime(pickupDate[1])}
                          </Tooltip>
                        }
                      >
                        <span>
                          {formatDatetime(pickupDate[0])} - {formatDatetime(pickupDate[1])}
                        </span>
                      </OverlayTrigger>
                    ) : (
                      formatDatetime(pickupDate)
                    )}
                  </div>
                </div>
                <div className="font-b5 text-right overflow-hidden text-truncate text-secondary w-90-px">
                  <span>{deliveryCity}</span>
                  <div className="font-b5 text-primary">{formatDatetime(deliveryDate)}</div>
                </div>
              </div>
            </div>
            {Cookies.get("listing_sizeperpage") !== "100" && (
              <div className="d-flex justify-content-between position-relative w-190-px">
                <div
                  style={{
                    width: 190,
                    height: 2,
                    borderBottom: `2px dotted black`,
                    position: "absolute",
                    top: 3,
                  }}
                />
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: "white",
                      border: "2px solid black",
                      zIndex: 10,
                    }}
                  />
                </div>

                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: "white",
                      border: "2px solid black",
                      zIndex: 10,
                    }}
                  />
                </div>
              </div>
            )}
          </>
        );
      },
    },
    ...(status !== "draft"
      ? [
          {
            Header: intl.formatMessage({
              id: "quote.listing.creationDate",
              defaultMessage: "Creation date",
            }),
            accessor: "created",
            group: intl.formatMessage({
              id: "columns.basic",
              defaultMessage: "Basic",
            }),
            Cell: ({ value }) => {
              const creationDateTime = moment(value, "YYYY-MM-DD hh:mm:ss").format("DD MMM YYYY - HH:mm");
              return <p className="mb-0">{creationDateTime}</p>;
            },
          } as Column,
        ]
      : []),
    ...(status !== "draft"
      ? [
          {
            id: "status",
            Header: intl.formatMessage({
              id: "general.status",
              defaultMessage: "Status",
            }),
            accessor: "display_status",
            group: intl.formatMessage({
              id: "columns.basic",
              defaultMessage: "Basic",
            }),
            sortable: true,
            Cell: ({ value: cellValue }) =>
              cellValue && (
                <div className="d-flex flex-column align-items-start">
                  <Badge type={QuickRequestStatusColors[cellValue.value] || "secondary"} label={cellValue.label} />
                </div>
              ),
          } as Column,
        ]
      : []),
    ...(status !== "draft"
      ? ([
          {
            Header: intl.formatMessage({ id: "new-request.packing-list.dangerousGoods", defaultMessage: "Dangerous goods" }),
            accessor: "dangerous_goods",
            group: intl.formatMessage({
              id: "columns.goodsInformation",
              defaultMessage: "Goods information",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "tableHeaders.totalWeightKg", defaultMessage: "Total weight (kg)" }),
            accessor: "total_weight_kg",
            group: intl.formatMessage({
              id: "columns.goodsInformation",
              defaultMessage: "Goods information",
            }),
            Cell: ({ value }) => <div>{formatWeight(value, "kg")}</div>,
          },
          {
            Header: intl.formatMessage({ id: "tableHeaders.totalWeightLbs", defaultMessage: "Total weight (lbs)" }),
            accessor: "total_weight_lbs",
            group: intl.formatMessage({
              id: "columns.goodsInformation",
              defaultMessage: "Goods information",
            }),
            Cell: ({ value }) => <div>{formatWeight(value, "lbs")}</div>,
          },
          {
            Header: intl.formatMessage({ id: "tableHeaders.totalVolumeCbm", defaultMessage: "Total volume (cbm)" }),
            accessor: "total_volume_cbm",
            group: intl.formatMessage({
              id: "columns.goodsInformation",
              defaultMessage: "Goods information",
            }),
            Cell: ({ value }) => (
              <div>
                {value || value === 0 ? (
                  <span>
                    {roundTo(value, 4)}m<sup>3</sup>
                  </span>
                ) : (
                  "-"
                )}
              </div>
            ),
          },
          {
            Header: intl.formatMessage({
              id: "tableHeaders.expectedPickupDateTime",
              defaultMessage: "Expected pickup date time",
            }),
            accessor: "expected_pickup_datetime",
            group: intl.formatMessage({
              id: "columns.schedule",
              defaultMessage: "Schedule",
            }),
            Cell: ({ value }) => (
              <div>
                {Array.isArray(value)
                  ? value.map((date) => formatIfValid(date, DateTimeFormat.fullDateTimeFormat)).join(" - ")
                  : formatIfValid(value, DateTimeFormat.fullDateTimeFormat)}
              </div>
            ),
          },
          {
            Header: intl.formatMessage({
              id: "tableHeaders.expectedDeliveryDateTime",
              defaultMessage: "Expected delivery date time",
            }),
            accessor: "expected_delivery_datetime",
            group: intl.formatMessage({
              id: "columns.schedule",
              defaultMessage: "Schedule",
            }),
            Cell: ({ value }) => (
              <div>
                {Array.isArray(value)
                  ? value.map((date) => formatIfValid(date, DateTimeFormat.fullDateTimeFormat)).join(" - ")
                  : formatIfValid(value, DateTimeFormat.fullDateTimeFormat)}
              </div>
            ),
          },
          {
            Header: intl.formatMessage({ id: "tableHeaders.exportClearance", defaultMessage: "Export clearance" }),
            accessor: "export_clearance",
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "quote-request-detail.transitClearance", defaultMessage: "Transit clearance" }),
            accessor: "transit_clearance",
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "quote-request-detail.importClearance", defaultMessage: "Import clearance" }),
            accessor: "import_clearance",
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({
              id: "new-request.service.serviceRequirement",
              defaultMessage: "Service requirement",
            }),
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            accessor: "service_requirement",
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "new-request.service.incoterms", defaultMessage: "Incoterms" }),
            accessor: "incoterms",
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "general.insurance", defaultMessage: "Insurance" }),
            accessor: "insurance",
            group: intl.formatMessage({
              id: "columns.service",
              defaultMessage: "Service",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: getLabel("Custom field 01", "capitalize"),
            accessor: "custom_field_01",
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: getLabel("Custom field 02", "capitalize"),
            accessor: "custom_field_02",
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: getLabel("Reason code", "capitalize", "", false, true),
            accessor: "reason_code",
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
          {
            Header: intl.formatMessage({ id: "tableHeaders.costCenter", defaultMessage: "Cost center" }),
            accessor: "cost_center",
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            Cell: ({ value }) => <div>{value || "-"}</div>,
          },
        ] as Column[])
      : []),
    ...(status !== "draft"
      ? [
          {
            Header: "",
            accessor: "quick_request_reference",
            actions: true,
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            disableDrag: true,
            Cell: ({ value, row }: any) => {
              const {
                status: quickRequestStatus,
                quick_request_reference: shipmentId,
                related_shipment: hasRelatedShipment,
              } = row.original;

              const canConvert = canCreateQuoteRequest && !hasRelatedShipment && quickRequestStatus !== "Canceled";
              const canEdit =
                quickRequestStatus !== "Canceled" && canCreateQuickRequest && !hasRelatedShipment && status !== "archived";
              const canDuplicate = canCreateQuickRequest;

              const [isActionInProgress, setIsActionInProgress] = useState(false);

              const handleConvertClick = () => {
                setIsActionInProgress(true);
                convertQuickRequest(shipmentId)
                  .then((res) => {
                    const draftReference = res.data.reference_number;
                    navigate(`/quote-request?draft_id=${draftReference}`);
                  })
                  .catch((err) => errorToast(err))
                  .finally(() => setIsActionInProgress(false));
              };
              const handleEditClick = () => {
                setIsActionInProgress(true);
                startEditQuickRequest(shipmentId)
                  .then((res) => navigate(`/quick-request/${shipmentId}/edit?draft_id=${res.data.draft_reference}`))
                  .catch((err) => errorToast(err))
                  .finally(() => setIsActionInProgress(false));
              };

              if (isActionInProgress) return <div className="spinner-border spinner-border-sm mr-2" role="status" />;
              return (
                <div
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {canDuplicate && <DuplicateShipment type="quick" reference={value} />}
                  {canEdit && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 0 }}
                      overlay={
                        <Tooltip id="button-tooltip">
                          <FormattedMessage id="general.edit" defaultMessage="Edit" />
                        </Tooltip>
                      }
                    >
                      <EditIcon onClick={handleEditClick} className="ml-2" height="18" width="18" />
                    </OverlayTrigger>
                  )}
                  {canConvert && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 0 }}
                      overlay={
                        <Tooltip id="button-tooltip">
                          <FormattedMessage id="components.molecules.navigation.convert" defaultMessage="Convert" />
                        </Tooltip>
                      }
                    >
                      <ResetIcon onClick={handleConvertClick} className="ml-2" height="18" width="18" />
                    </OverlayTrigger>
                  )}
                </div>
              );
            },
          } as Column,
        ]
      : [
          {
            id: "last_modified",
            Header: intl.formatMessage({ id: "general.lastModified", defaultMessage: "Last Modified" }),
            accessor: "modified",
            group: intl.formatMessage({
              id: "columns.other",
              defaultMessage: "Other",
            }),
            Cell: ({ value }: any) => (
              <p className="mb-0">
                {moment(value, "YYYY-MM-DD HH:mm:ss").fromNow(true)}{" "}
                <FormattedMessage id="general.ago" defaultMessage="ago" />
              </p>
            ),
          },
        ]),
  ];

  // if no custom label exists for the custom field, remove it from the column list
  if (getLabel("Custom field 01", "capitalize") === "Custom field 01") {
    columns = columns.filter((column) => column.Header !== "Custom field 01");
  }
  if (getLabel("Custom field 02", "capitalize") === "Custom field 02") {
    columns = columns.filter((column) => column.Header !== "Custom field 02");
  }

  return columns;
};

export default getQuickListingColumns;
